import { IfQuickReloadFlushEverything } from "./cache.js";
import { controlStartUp } from "./control.js";
import { i18nGetPageLanguage } from "./i18n.js";
import { pageFetchPosters, pageGetPostersNumber } from "./page.js";
import { posterAppendAuthor, posterParse, posterRender } from "./poster.js";
import {
    postersSetIndexMode,
    postersSetPublisherFilter,
    postersUnescapeSpacesAndApostrophes
} from "./posters.js";

function spaceShowEmptyMessage(wrapper) {
    const element = document.createElement("p");
    element.className = "spacePageEmpty";
    element.textContent = i18nGetPageLanguage() === "es"
        ? "Ahora mismo no hay carteles publicados en esta sección."
        : "Ara mateix no hi ha cartells publicats en aquesta secció.";
    wrapper.appendChild(element);
}

async function spaceStartUp(publisherId, escapedSuperLabel) {
    const wrapper = document.getElementById("mainPostersWrapper");
    const loader = document.getElementById("mainLoader");
    if (!wrapper) {
        return;
    }

    if (wrapper.dataset.postersLoaded === "true") {
        posterRender(wrapper);
        Array.from(wrapper.getElementsByClassName("posterWrapper")).forEach((poster) => {
            posterAppendAuthor(poster);
            posterParse(poster);
        });
        return;
    }

    if (loader) {
        loader.style.display = "inline-block";
    }
    if (await IfQuickReloadFlushEverything()) {
        return;
    }

    const superLabel = postersUnescapeSpacesAndApostrophes(escapedSuperLabel || "");
    controlStartUp("mainSentinel");
    postersSetIndexMode("main");
    try {
        await pageFetchPosters(wrapper, "", "", superLabel, 0, "", null, {
            forceFullPage: true,
            publisherId: publisherId || "",
            targetPostersNumber: 20
        });
        if (pageGetPostersNumber() === 0) {
            spaceShowEmptyMessage(wrapper);
        }
        wrapper.dataset.postersLoaded = "true";
    } finally {
        postersSetPublisherFilter("");
        if (loader) {
            loader.style.display = "none";
        }
    }
}

export { spaceStartUp };
